// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"318d9fa3","160":"80c59c5a","208":"6f0fed91","293":"e8c9202c","453":"600478a0","516":"03f50f57","519":"c0b6b96a","917":"8a1a223f","946":"2e9f4542"}[chunkId] + ".chunk.js";
};